import React, { Suspense, lazy } from 'react'
import { LoadingLogo } from '@/components/atoms/LoadingLogo/LoadingLogo'
import PageWrapper from '@/components/organisms/PageWrapper/PageWrapper'

// Carga los componentes de manera dinámica y especifica la importación de 'default'
const BannerHome = lazy(
	async () =>
		await import('@/components/templates/BannerHome/BannerHomeVideo').then((module) => ({
			default: module.default
		}))
)

const OurServicesAreti = lazy(
	async () =>
		await import('@/components/templates/OurServicesAreti/OurServicesAreti').then(
			(module) => ({ default: module.default })
		)
)

const OurServicesAretiGrid = lazy(
	async () =>
		await import('@/components/templates/OurServicesAretiGrid/OurServicesAretiGrid').then(
			(module) => ({ default: module.default })
		)
)

const GetALoan = lazy(
	async () =>
		await import('@/components/templates/GetALoan/GetALoan').then(
			(module) => ({ default: module.default })
		)
)

const AboutUsAreti = lazy(
	async () =>
		await import('@/components/templates/AboutUsAreti/AboutUsAreti').then(
			(module) => ({ default: module.default })
		)
)

const FormContactUsAreti = lazy(
	async () =>
		await import('@/components/templates/FormContactUsAreti/FormContactUsAreti').then(
			(module) => ({ default: module.default })
		)
)

const Footer = lazy(
	async () =>
		await import('@/components/organisms/Footer/Footer').then((module) => ({
			default: module.default
		}))
)

export const Home: React.FC = () => {
	const buildDate = new Date().toISOString()

	return (
		<PageWrapper
			title='Areti Holdings'
			description='Areti Holdings offers secure and innovative solutions for payments the management of business payments, risk management and corporate trade finance. Streamline your business with our expertise.'
			url='https://www.aretiholdings.io'
			keywords={[
				'Areti',
				'Areti Holdings',
				'Trade finance solutions',
				'Trading Corporation',
				'International Financial transactions',
				'Secure International payments',
				'Financial risk management',
				'Specialized financing',
				'Innovative financial services',
				'Global business solutions',
				'International supplier payments',
				'Secure and innovative financial solutions for businesses in Hong Kong.',
				'Optimise your international payments with Areti Holdings',
				'Mitigate financial risks and expand globally',
				'Tailor-made trade finance solutions for Hong Kong companies',
				'Secure, efficient and innovative: Areti Holdings'
			]}
			language='en'
			publishedTime={buildDate}
		>
			<Suspense fallback={<LoadingLogo />}>
				<div className=''>
					{/* <Header /> */}
					<main className='flex-grow'>
						<section id='home'>
							<BannerHome />
						</section>
						<section id='services'>
							<OurServicesAreti />
						</section>
						<section id='services'>
							<OurServicesAretiGrid />
						</section>
						<section id='GetALoan'>
							<GetALoan />
						</section>
						<section id='aboutUs'>
							<AboutUsAreti />
						</section>
						<section id='formContactUs'>
							<FormContactUsAreti />
						</section>
					</main>
					<Footer />
				</div>
			</Suspense>
		</PageWrapper>
	)
}
